<template>
  <div class="share-row container-landing">
    <span class="bold-italic f-16">{{$fn.tr('გააზიარე')}}:</span>
    <div class="socials-row">
     
      <template v-for="(icon, index) in getShareLinks">
                    <div
                      class="share-icon"
                      v-html="icon.svg"
                      :key="index"
                      @click.stop="openSharePopup(icon.url)"
                      target="_blank"
                      :href="icon.url"
                    ></div>
        </template>




<div class="share-icon copy-link" @click="copyLink">
  <div class="tool-tip">
    <span class="f-16 light-italic" v-if="!copied">{{$fn.tr('ლინკის დაკოპირება')}}</span>
    <span class="f-16 light-italic" v-if="copied">{{$fn.tr('ლინკი დაკოპირდა')}}</span>
  </div>
<svg xmlns="http://www.w3.org/2000/svg" width="19.995" height="20" viewBox="0 0 19.995 20">
  <g id="fi-rr-link" transform="translate(-0.001)">
    <g id="Group_1818" data-name="Group 1818" transform="translate(0.001 0)">
      <path id="Path_3795" data-name="Path 3795" d="M11.536,15.8,8.818,18.514a4.189,4.189,0,1,1-5.925-5.924L5.611,9.87A.833.833,0,0,0,4.432,8.692L1.715,11.413A5.856,5.856,0,0,0,10,19.692l2.718-2.718A.833.833,0,1,0,11.539,15.8Z" transform="translate(-0.001 -1.409)" fill="#101820"/>
      <path id="Path_3796" data-name="Path 3796" d="M19.693,1.717a5.853,5.853,0,0,0-8.28,0L8.691,4.433A.833.833,0,1,0,9.869,5.612L12.59,2.894a4.189,4.189,0,0,1,5.923,5.924l-2.718,2.718a.834.834,0,0,0,1.179,1.179L19.691,10a5.863,5.863,0,0,0,0-8.282Z" transform="translate(-1.409 0)" fill="#101820"/>
      <path id="Path_3797" data-name="Path 3797" d="M13.244,8.244l-5,5a.833.833,0,1,0,1.178,1.178l5-5a.833.833,0,1,0-1.178-1.178Z" transform="translate(-1.335 -1.334)" fill="#101820"/>
    </g>
  </g>
</svg>
</div>

    </div>
    <svg id="share-line" xmlns="http://www.w3.org/2000/svg" width="1110" height="2.286" viewBox="0 0 1110 2.286">
  <path id="Path_3947" data-name="Path 3947" d="M68.064,8.363c319.278-.9,642.638.081,963.423-.492,81.313-.145,128.708-1.94,19.2-1.745C729.825,6.7,407.15,5.721,87.269,6.619,7.792,6.842-41,8.67,68.064,8.363Z" transform="translate(-4.75 -6.112)" fill="#3a5aa7" opacity="0.2"/>
</svg>

  </div>
</template>

<script>
export default {
  data(){
    return{
      copied: false,
    }
  },
  computed: {
     getShareLinks() {
      let socialList = [];
      let socialSvgs = _.get(this.$store.state.main.indx, "widgets.share_icons");
      let uri = encodeURI(
        window.location.protocol + "//" + window.location.host + "" +  this.$route.path + window.location.search
      );

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: socialSvgs[i].svg,
          url: socialSvgs[i].url + uri
        });
      }

      return socialList;
    },

  //  tooltipText(){
  //    if(this.$route.name == 'ge' && this.copied){
         
  //          return  moment(d).locale('ka').format("DD MMM YYYY");
  //        } else if(this.$route.name == 'en'){
         
  //        return  moment(d).locale('en').format("DD MMM YYYY");
  //       }
  //  }

  },
  methods: {
     openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    },

    copyLink(){
      var dummy = document.createElement('input'),
      text = window.location.href;
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        

      this.copied = true;
      console.log(window.location.href)
    }

  },
   mounted(){
      console.log(this.getShareLinks);
    }
}
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>
.share-icon{
  &:not(:last-child){
    padding-right: 34px;
  }
}
.copy-link{
  position: relative;
  .tool-tip{
    position: absolute;
    top: -15px;
    left: 45px;
    pointer-events: none;
    opacity: 0;
    transition: .4s;
    background-color: #F7F8FA;
    display: flex;
    width: fit-content;
    min-width: 230px;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 15px;
    padding-bottom: 10px;
    height: auto;
    border-radius: 40px;
    span{
      display: inline-block;
    }
    @media (max-width: 767px){
      min-width: 180px;
      left: 35px;
    }
  }
  
    &:hover{
      .tool-tip{
      opacity: 1;
    }
    }
    
  
}
</style>